module.exports = __webpack_public_path__ + "img/lampa-7.d67b9883.jpg";